import useApiRequest from "../common/useApiRequest";
import { useQuery } from "@tanstack/react-query";
import { SudoUser } from "@shared/types/user";

export const useSudoUser = (enabled: boolean) => {
  const { GET } = useApiRequest();
  
  const fetchSudoUser = async (): Promise<SudoUser> => {
    const userData: SudoUser = await GET("/api/user/me/session/current");
    return userData;
  };

  return useQuery<SudoUser, Error>({
    queryKey: ["sudo-user"],
    queryFn: fetchSudoUser,
    enabled,
  });
};

